import { Component, Inject, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { DIALOG_DATA, DialogRef } from "@angular/cdk/dialog";
import { JsonPipe } from "@angular/common";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DialogOverlayComponent } from "../ui/dialog-overlay/dialog-overlay.component";
import { ButtonComponent } from "../ui/button/button.component";

@Component({
  standalone: true,
  imports: [ButtonComponent, TranslateModule, DialogOverlayComponent],
  templateUrl: "./dialog-aiball.component.html",
  styleUrls: ["./dialog-aiball.component.scss"],
  selector: "dialog-aiball",
})
/**
 * Dialog component. It is used to show a dialog with a title and a message.
 * By default it has two buttons: one to cancel the action and another to confirm it.
 * Otherwise, you can add custom buttoms.
 */
export class DialogAiball {
  @Input() data: {
    title: string;
    message: string;
    buttonsConfig?: any[];
    imageUrl?: string;
    imageStyle?: string;
    preventDialogFromClose?: boolean;
    callback?: any;
  } = {
    title: "",
    message: "",
    buttonsConfig: undefined,
    imageUrl: undefined,
    imageStyle: "",
    preventDialogFromClose: false,
    callback: undefined,
  };
  constructor(public activeModal: NgbActiveModal) {}

  closeDialog(action: string, callback: Function | null = null) {
    if (!!callback) callback();
    if (!this.data.preventDialogFromClose)
      this.activeModal.close({ action: action });
  }
}
